<template>
  <div v-if="open">
    <div  v-if="status === 1" @click="toAppisDownload" id="ConferenceRegistration">
      <van-icon
        style="line-height: 27px"
        color="#2F91FF"
        size="22"
        name="records"
      />
      <p style="color: #2f91ff; font-size: 8px; line-height: 8px">报名</p>
    </div>
    <div v-if="status === 2 || status === 3 || status === 4 || status === 5" :class="{ end: !isBack }" class="EndOfRegistration">
      <span>{{ status | registrationStatus }}</span>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "",
  components: {},
  props: {},
  filters: {
    // 报名状态
    registrationStatus(num) {
      if (num === 1) return "报名已开启";
      if (num === 2) return "报名未开启";
      if (num === 3 || num === 4 || num === 5) return "报名已截止";
    },
  },
  data() {
    return {
      open: true,
      isBack: false,
      tickets: [],
      hyBeginTime: "",
      hyendTime: "",
      status: null,
      isFull: false, // 会议报名人数是否到达上限
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getSignUpInfo();
  },
  mounted() {},
  methods: {
    async getSignUpInfo() {
      const res = await this.$apis.userServe.getSignUpInfo({
        id: this.$route.query.id,
      });
      if (res.resultCode === "200") {
        this.tickets = res.data.tickets;
        this.hyBeginTime = res.data.beginTime;
        this.hyendTime = res.data.endTime;
        this.isFull = res.content.full === 1;
        this.getState();
      } else {
        this.open = false;
      }
    },
    // 会议状态判断处理函数
    judgeState(bmBegin, bmEnd, hyBegin, hyEnd) {
      // ios 时间处理应该用/不能用-
      let RealTime = new Date().getTime(); // 实时时间
      let bmBegins = new Date(bmBegin.replace(/-/g, "/")).getTime(); // 报名开始

      // 将报名结束时间改为当天最后时间
      let arr = bmEnd.split(" ")
      arr[1] = "23:59:59"
      let bmEndTime = arr.join(' ')
      let bmEnds = new Date(bmEndTime.replace(/-/g, "/")).getTime(); // 报名结束
      
      let hyBegins = new Date(hyBegin.replace(/-/g, "/")).getTime(); // 会议开始
      let hyEnds = new Date(hyEnd.replace(/-/g, "/")).getTime(); // 会议结束
      if (RealTime >= hyEnds) {
        // 会议结束
        return 5;
      } else if (RealTime >= hyBegins && RealTime <= hyEnds) {
        // 会议已开始
        return 4;
      } else if (RealTime >= bmEnds || this.isFull) {
        // 会议已截止 (超过报名时间或者报名人数上限)
        return 3;
      } else if (RealTime < bmBegins) {
        // 报名未开启
        return 2;
      } else if (RealTime >= bmBegins && RealTime < bmEnds) {
        // 报名已开始
        return 1;
      }
    },
    getState() {
      let bmBegin = this.tickets[0].beginTime;
      let bmEnd = this.tickets[0].endTime;
      let hyBegin = this.hyBeginTime;
      let hyEnd = this.hyendTime;
      this.status = this.judgeState(bmBegin, bmEnd, hyBegin, hyEnd);
    },
    async toSign() {
      let id = this.$route.query.id.toString();
      if (this.$route.query.out) {
        let obj = {
          articleId: id,
          articleType: 8,
        };
        let res = await this.$apis.mainServe.hasFile(obj);
        if (res.resultCode === "1009") {
          if (this.$global.isAndroid_ios()) {
            window.android.getToken();
          } else {
            window.webkit.messageHandlers.getToken.postMessage("null"); //ios
          }
        } else {
          if (this.$global.isAndroid_ios()) {
            window.android.meetingRegistration(id);
          } else {
            window.webkit.messageHandlers.meetingRegistration.postMessage(id); //ios
          }
        }
      } else {
        this.$router.push("/jumpdownload");
      }
    },
    toAppisDownload() {
      switch (this.status) {
        case 1:
          this.toSign();
          break;
        case 2:
          Toast({
            message: "报名未开启",
            position: "top",
          });
          break;
        case 3:
        case 4:
        case 5:
          Toast({
            message: "报名已截止",
            position: "top",
          });
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
#ConferenceRegistration {
  width: 45px;
  height: 45px;
  border: 2px solid #2f91ff;
  background: rgba(255, 255, 255, 0.37);
  border-radius: 50%;
  text-align: center;
  color: #fff;
  margin-bottom: 10px;
}
.EndOfRegistration {
  width: 45px;
  height: 45px;
  background: rgb(47, 145, 255);
  border-radius: 50%;
  text-align: center;
  color: rgb(255, 255, 255);
  font-size: 12px;
  padding-top: 6px;
  margin-bottom: 10px;
}
.end {
  background: rgba(0, 0, 0, 0.61);
}
</style>
